import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map } from "rxjs/operators";
import { StorageNativeStoreAction } from "src/components/shared-components/enum/enumStoreAction";
import { serverSettingsUnsetKeyStorageAction } from "../actions/server-settings.action";

/**
 * Handle server settings effect effects
 */
@Injectable()
export class ServerSettingsEffects {
  constructor(private _actions$: Actions) { }

  /**
   * Effect who catch main event and unset specific server key storage
   */
  public serverSettingsUnsetKeyEffect = createEffect(() =>
    this._actions$.pipe(
      ofType(StorageNativeStoreAction.STORAGE_UNSET_ALL_AUTH_KEY),
      map((action) => serverSettingsUnsetKeyStorageAction())
    )
  );
}
